import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade, Controller, EffectCreative, Parallax, Pagination, Keyboard, Mousewheel } from 'swiper/modules';
import { qs, qsa } from '../utils/dom';

const swiperInstances = [];

function isValidSwiperRoot(el) {
  return el instanceof Element && !!el.querySelector(':scope > .swiper-wrapper');
}

function initSliderDouble() {
  document.querySelectorAll('.slider-double--slider-main.swiper').forEach((mainEl) => {
    const parent = mainEl.closest('.slider-double--wrapper-bottom') || mainEl.parentElement;
    if (!parent) return;

    const secondaryEl = parent.querySelector('.slider-double--slider-secondary.swiper');
    if (!secondaryEl) return;

    const prevEl = parent.querySelector('.slider-double--arrows-main .slider-double--arrow.prev');
    const nextEl = parent.querySelector('.slider-double--arrows-main .slider-double--arrow.next');

    if (!mainEl.querySelector(':scope > .swiper-wrapper')) return;
    if (!secondaryEl.querySelector(':scope > .swiper-wrapper')) return;

    const mainSwiper = new Swiper(mainEl, {
      modules: [Navigation, Autoplay, Controller],
      loop: true,
      speed: 1000,
      autoplay: { delay: 4000, disableOnInteraction: false },
      navigation: {
        prevEl: prevEl || undefined,
        nextEl: nextEl || undefined,
      },
    });

    const secondarySwiper = new Swiper(secondaryEl, {
      modules: [EffectFade, Autoplay, Controller],
      loop: true,
      speed: 1000,
      effect: 'fade',
      slidesPerView: 1,
      fadeEffect: { crossFade: true },
      autoplay: { delay: 4000, disableOnInteraction: false },
      allowTouchMove: false,
    });

    mainSwiper.controller.control = secondarySwiper;
    secondarySwiper.controller.control = mainSwiper;

    swiperInstances.push(mainSwiper, secondarySwiper);
  });
}

function initSliderSimple() {
  qsa('.slider-simple--slider').forEach((el) => {
    if (!isValidSwiperRoot(el)) return;

    const swiper = new Swiper(el, {
      modules: [Autoplay],
      loop: false,
      slidesPerView: 2,
      speed: 5000,
      autoplay: { delay: 0, disableOnInteraction: false },
      allowTouchMove: false,
      breakpoints: { 768: { slidesPerView: 2 } },
    });

    swiperInstances.push(swiper);
  });
}

function initHeroSliders() {
  qsa('.hero-slider--slider').forEach((el) => {
    if (!isValidSwiperRoot(el)) return;

    const swiper = new Swiper(el, {
      modules: [Autoplay, EffectCreative, Parallax, Pagination, Keyboard, Mousewheel],
      loop: true,
      grabCursor: false,
      parallax: false,
      effect: "creative",
      mousewheel: true,
      speed: 2000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
      autoplay: { delay: 4000, disableOnInteraction: false },
      creativeEffect: {
        prev: {
          shadow: true,
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
      breakpoints: {
        900: {
          parallax: true,
        },
      },
    });

    swiperInstances.push(swiper);
  });
}

function initSliderProduct() {
  qsa('.slider-product--slider').forEach((el) => {
    if (!isValidSwiperRoot(el)) return;

    const parent = el.closest('.slider-product--slider');
    if (!parent) return;

    const nextEl = parent.querySelector('.slider-product--arrows-main .slider-product--arrow.next');

    // Count slides to conditionally hide the arrow
    const slidesCount = el.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
    if (slidesCount <= 4 && nextEl) {
      nextEl.style.display = 'none';
    }

    const swiper = new Swiper(el, {
      modules: [Controller, Autoplay, Navigation],
      loop: true,
      infinite: true,
      slidesPerView: 2,
      spaceBetween: 30,
      speed: 3000,
      autoplay: { delay: 2000, disableOnInteraction: false },
      allowTouchMove: true,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: nextEl || undefined,
      },
    });

    swiperInstances.push(swiper);
  });
}

export function destroySliders() {
  swiperInstances.forEach(swiper => swiper.destroy(true, true));
  swiperInstances.length = 0;
}

export function initSliders() {
  if (!document.querySelector('.slider-double--slider-main, .slider-simple--slider, .hero-slider--slider, .slider-product--slider')) {
    return;
  }
  initSliderDouble();
  initSliderSimple();
  initSliderProduct();
  initHeroSliders();
}